import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Typography from '@mui/material/Typography'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import InputBase from '@mui/material/InputBase'
import Paper from '@mui/material/Paper'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import { visuallyHidden } from '@mui/utils'
import AppBar from '../components/app-bar'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { MenuItem, CircularProgress, Button, Dialog, DialogTitle, DialogActions, AccordionDetails, makeStyles, Select, TextField } from '@material-ui/core'
import { customTheme } from '../styling'
import axios from '../axios'
import moment from 'moment'
import GeneralError from '../components/error'
import SnackBar from '../components/snackbar'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'
import { List, ListItem, Popover, Tab, Tabs } from '@mui/material'
import { getRoleUserIdFromToken, getUserIdFromToken } from '../utils'
import { SearchBar } from '../components/search-bar.tsx'


const useStyles = makeStyles((theme) => ({
    generateCodeContainer: {
        width: '100%',
        marginTop: '1.5rem',
    },
    appBarSpacer: theme.mixins.toolbar,
    uploadFile: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        overflowX: 'hidden',
        marginLeft: '1rem',
        width: '90%',
        height: '20vh',
        display: 'flex',
        textAlign: 'center',
        border: `1px solid ${customTheme.colors.ui.grey}`,
        borderStyle: 'dotted',
        marginBottom: '0.3rem'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: '100vh',
        overflow: 'auto',
    },
    title: {
        color: 'black',
    },
    selectBoxMain: {
        width: '80vw',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        position: 'absolute',
        top: '40%',
        cursor: 'pointer'
    },
    selectBox: {
        width: '35%',
        backgroundColor: customTheme.colors.ui.ligthBlue,
        padding: '1.5rem 3.5rem',
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
            opacity: '0.8'
        },
    },
    loadingContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    formControl: {
        minWidth: 300, marginRight: '1.5rem'
    },
    dialogActions: {
        marginTop: '1rem'
    },
    contentContainer: {
        padding: '2rem'
    },
    textarea: {
        fontSize: '1rem',
        border: '1px solid #000',
        paddingLeft: '0.5rem',
        paddingTop: '0.5rem',
        resize: 'none',
        width: '100%',
        borderRadius: '8px',
        height: '30vh',
        '&:focus': {
          outline: 'none !important',
          outlineColor: customTheme.colors.ui.grey,
          border: `1px solid ${customTheme.colors.ui.grey} !important`
        },
      },

}))



const rows = []



const headCells = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: 'Codice cliente',
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Nome cliente',
    },
    {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'P.Iva',
    },
    {
        id: 'agents',
        numeric: false,
        disablePadding: false,
        label: 'Agente',
    },
]

const EnhancedTableHead = (props) => {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
        props
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property)
    }
    const roleUserId = getRoleUserIdFromToken()
    const headCellsFormatted = roleUserId === 2 ? headCells.slice(0, 3) : headCells
    return (
        <TableHead style={{ backgroundColor: customTheme.colors.ui.greyLight, }}>
            <TableRow>
                {headCellsFormatted.map((headCell, index) => (
                    <TableCell
                    style={{color:'black'}}
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.label}
                    </TableCell>
                    
                ))}
                 <TableCell

> </TableCell>
            </TableRow>
        </TableHead>
    )
}



const Clients = () => {
    const [order, setOrder] = React.useState('asc')
    const [orderBy, setOrderBy] = React.useState('calories')
    const [selected, setSelected] = React.useState([])
    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [addClientOpen, setAddClientOpen] = useState(false)
    const [client, setClient] = useState(null)
    const [creatingClient, setCreatingClient] = useState(false)
    const [clients, setClients] = useState([])
    const [description, setDescription] = useState(null)
    const [nameProduct, setNameProduct] = useState(null)
    const [firstName, setFirstName] = useState(null)
    const [lastName, setLastName] = useState(null)
    const [nameCompany, setNameCompany] = useState(null)
    const [fiscalCode, setFiscalCode] = useState(null)
    const [pIva, setPIva] = useState(null)
    const [username, setUsername] = useState(null)
    const [telNumber, setTelNumber] = useState(null)
    const [addressShipment, setAddressShipment] = useState(null)
    const [registeredOffice, setRegisteredOffice] = useState(null)
    const [longDescription, setLongDescription] = useState(null)
    const [tab, setTab] = useState(0)
    const [anchorElModifyClient, setAnchorElModifyClient] = useState(null)
    const [currentClient, setCurrentClient] = useState(null)
    const [unitAvailable, setUnitAvailable] = useState(null)
    const [price, setPrice] = useState(null)
    const classes = useStyles()
    const { enqueueSnackbar } = SnackBar.Consumer()
    const [currentInputSearch, setCurrentInputSearch] = useState('')
    const [agents, setAgents] = useState([])
    const [agent, setAgent] = useState(null)
    const roleUserId = getRoleUserIdFromToken()
    const userId = getUserIdFromToken()
    const openModifyClient = Boolean(anchorElModifyClient)
    const idModifyClient = openModifyClient ? 'simple-popover-modify-client' : undefined
    const [confirmDeleteClient, setConfirmDeleteClient] = useState(false)
    const [currentClientId, setCurrentClientId] = useState(null)
    const [deletingClient, setDeletingClient] = useState(false)
   
    const getClients = async (status=1, search=null) => {
        let url = '/get-list-clients'
        if(search){
            url = `/get-list-clients?search=${currentInputSearch}`
        }
        const clients = await axios.get(url)
        const clientsData = clients.data
        return clientsData
    }

    const getInitialData = async () => {
        const clients = await getClients()
        const agents = await axios.get('/get-list-agents')
        return { clients, agents }
    }

    useEffect(() => {
        setLoading(true)
        getInitialData().then((res) => {
            setClients(res.clients)
            setAgents(res.agents.data)
        }).catch((error) => {
            setError(true)
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }



    const handleCloseAddUser = () => {
        setAddClientOpen(false)
        setFirstName(null)
        setAgent(null)
        setLastName(null)
        setNameCompany(null)
        setPIva(null)
        setFiscalCode(null)
        setAddressShipment(null)
        setRegisteredOffice(null)
        setUsername(null)
        setTelNumber(null)
    }   


    const handleSave = () => {
        const body = {
            agentId:roleUserId === 2 ? userId : agent,
            nameCompany,
            firstName,
            lastName,
            fiscalCode,
            pIva,
            username,
            telNumber,
            addressShipment,
            registeredOffice,
        }
        if(addClientOpen){
            body.id = addClientOpen.id
        }
        setCreatingClient(true)
        axios.post(`/create-client`, body).then(() => {
            setNameCompany(null)
            setFirstName(null)
            setAgent(null)
            setLastName(null)
            setFiscalCode(null)
            setPIva(null)
            setUsername(null)
            setTelNumber(null)
            setAddressShipment(null)
            setRegisteredOffice(null)
            handleCloseAddUser()
            setCurrentClient(null)
            enqueueSnackbar({ variant: 'success', message: addClientOpen ? 'Cliente salvato correttamente' :'Cliente creato correttamente' })
            getInitialData().then((res) => {
                setClients(res.clients)
                setAddClientOpen(false)
            }).catch((error) => {
                setError(true)
            }).finally(() => {
                setLoading(false)
            })

        }).catch((error) => {
            console.log(error)
            enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
        }).finally(() => {
            setCreatingClient(false)
        })
    }

    const handleChangeTab = async (value) => {
        setTab(value)
        const clients = await getClients(value + 1)
        setClients(clients)
    }



    const handleInputSearchChange = (event) => {
        setCurrentInputSearch(event.target.value)
    }

    const handleSearchClients = () => {
        setLoading(true)
        getClients(tab +1, currentInputSearch).then((res) => {
          setClients(res)
          setLoading(false)
        }).catch(() => {
          setLoading(false)
          enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
            variant: 'error',
          })
    
        })
      }

      const handleClearInput = () => {
        setCurrentInputSearch('')
        getClients(tab + 1).then((res) => {
            setClients(res)
            setLoading(false)
          }).catch(() => {
            setLoading(false)
            enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
              variant: 'error',
            })
      
          })
      }

      const handleDeleteClient = () => {
        setDeletingClient(true)
        axios.post('/delete-client', { id: currentClientId }).then((res) => {
        setClients(clients.filter(({ id }) => id !== currentClientId))
        setCurrentClientId(null)
        setDeletingClient(false)
        setConfirmDeleteClient(false)
        enqueueSnackbar('Cliente elliminato correttamente', {
            variant: 'success',
        })
    }).catch((error) => {
      if (error.status === 400) {
        enqueueSnackbar(error.response.data.message, {
          variant: 'error',
        })
      } else {
        enqueueSnackbar(INTERNAL_SERVER_ERROR_MESSAGE, {
          variant: 'error',
        })
      }
      setDeletingClient(false)
    })
      }


    return (
        <AppBar>
             <Dialog open={confirmDeleteClient}>
             <CloseIcon onClick={() => setConfirmDeleteClient(false)} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
        <Box style={{ width: '25rem', padding: '2rem 1rem 1rem 1rem', borderRadius: '12px', }} >
          <List>
            <ListItem style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box style={{ width: '25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                <Typography>Sei sicuro di voler eliminare questo cliente?</Typography>

                <Box display={'flex'} flexDirection={'row'}>
                  <Button onClick={() => {
                    setConfirmDeleteClient(false)
                  }} style={{ marginTop: '1rem', width: '6rem', marginRight: '1rem' }} variant='contained' color='default'>{'Annulla'}</Button>
                  <Button onClick={() => handleDeleteClient()} style={{ marginTop: '1rem', width: '6rem', backgroundColor: customTheme.colors.ui.red, color: 'white' }} variant='contained'>{deletingClient ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Ellimina'}</Button>
                </Box>




              </Box>
            </ListItem>
          </List>
        </Box>
      </Dialog>

            
            <Dialog
                fullWidth={true}
                maxWidth="md"
                className={classes.dialogContainer}
                open={addClientOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={() => handleCloseAddUser()} style={{float:'right', position:'absolute', right:10, top:10, cursor:'pointer'}} />
                <Box className={classes.contentContainer}>
                    <Box className={classes.titleContainer}>
                        <DialogTitle id="alert-dialog-title" className={classes.title}>
                            Dettagli cliente
                        </DialogTitle>
                    </Box>
                    <div>
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Nome
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Nome' fullWidth={true} variant='outlined'  value={firstName} onChange={event => setFirstName(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Cognome
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Cognome' fullWidth={true} variant='outlined'  value={lastName} onChange={event => setLastName(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Nome società
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Nome società' fullWidth={true}  variant='outlined'  value={nameCompany} onChange={event => setNameCompany(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>

                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                   Partita IVA
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Partita IVA' fullWidth={true}  variant='outlined'  value={pIva} onChange={event => setPIva(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            <Box width={'50%'}>
                                <AccordionDetails>
                                    Codice fiscale
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Codice fiscale' fullWidth={true}  variant='outlined'  value={fiscalCode} onChange={event => setFiscalCode(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>
                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                           
                            <Box width={'100%'}>
                                <AccordionDetails>
                                    Sede Legale
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Indirizzo sede Legale' fullWidth={true}  variant='outlined' value={registeredOffice} onChange={event => setRegisteredOffice(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>

                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                           
                            <Box width={'100%'}>
                                <AccordionDetails>
                                    Indirizzo di consegna
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Indirizzo di consegna' fullWidth={true}  variant='outlined' value={addressShipment} onChange={event => setAddressShipment(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>

                        {roleUserId !== 2 && <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                           
                           <Box width={'100%'}>
                               <AccordionDetails>
                                 Agente
                               </AccordionDetails>
                               <AccordionDetails>
                               <Select
                            MenuProps={{
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left"
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "left"
                                },
                                getContentAnchorEl: null
                              }}
                                fullWidth={true}
                                variant='outlined'
                                value={agent}
                                onChange={(event) => setAgent(event.target.value)}
                            >
                                {agents.map(({ id, nameCompany }) => <MenuItem key={id} value={id}>{nameCompany}</MenuItem>)}

                            </Select>
                               </AccordionDetails>
                           </Box>
                           
                       </Box>
                        }

                        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            {/* <Box width={'50%'}>
                                <AccordionDetails>
                                   Email di contatto
                                </AccordionDetails>
                                <AccordionDetails>
                                <TextField placeholder='Email di contatto'  fullWidth={true} variant='outlined' value={username} onChange={event => setUsername(event.target.value)} />
                                </AccordionDetails>
                            </Box> */}
                            <Box width={'50%'}>
                                <AccordionDetails>
                                Numero di contatto
                                </AccordionDetails>
                                <AccordionDetails>
                                    <TextField placeholder='Numero di contatto' fullWidth={true}  variant='outlined'  value={telNumber}  onChange={event => setTelNumber(event.target.value)} />
                                </AccordionDetails>
                            </Box>
                            
                        </Box>



                    </div>
                    <DialogActions className={classes.dialogActions}>
                        <Button style={{ width: '12rem' }} onClick={() => handleCloseAddUser()} variant='contained' color='default'>Annulla</Button>
                        <Button style={{ width: '12rem' }} onClick={() => handleSave()} variant='contained' color='primary'>
                            {creatingClient ? <CircularProgress style={{ color: 'white' }} size={22} /> : 'Salva cliente'}
                        </Button>
                    </DialogActions>

                </Box>
            </Dialog>
            {error ? <GeneralError /> : loading ?
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Typography className={classes.title} variant="h5" gutterBottom component="h2">
                        Clienti
                    </Typography>

                    <Box className={classes.loadingContainer}>
                        <CircularProgress />
                    </Box>
                </main>
                :
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />

                    <Typography style={{float:'left'}} className={classes.title} variant="h5" gutterBottom component="h2">
                        Clienti
                    </Typography>

                   

                    <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        style={{ height: '2.5rem',  float: 'right', width: '200px', color: customTheme.colors.ui.green, border: `1px solid ${customTheme.colors.ui.green}` }}
                        onClick={() => setAddClientOpen(true)}
                    >
                        Aggiungi cliente
                    </Button>
                    {/* <Box
                        component="form"
                        style={{ height: '2.5rem', borderRadius: '5px', border: `1px solid ${'black'}`, alignItems: 'center', width: 300, float: 'right', marginRight: '1rem' }}
                    >
                        <Button sx={{ padding: '5px', color: 'black' }} onClick={() => currentInputSearch && handleSearchClients()}>
                            <SearchIcon color='black' />
                        </Button>
                        <InputBase
                            value={currentInputSearch}
                            sx={{ ml: 1, flex: 1 }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    if (currentInputSearch) {
                                        handleSearchClients()
                                    }
                                    // Do code here
                                    event.preventDefault()
                                }
                            }}
                            placeholder="Cerca..."
                            inputProps={{ 'aria-label': 'Cerca' }}
                            onChange={(event) => handleInputSearchChange(event)}
                        />

                        <CloseIcon onClick={() => handleClearInput()} style={{ position: 'relative', left: '1.5rem', cursor: 'pointer', top: '0.4rem' }} />



                    </Box> */}
                    <SearchBar
                        placeholder='Cerca Clienti …'
                        value={currentInputSearch}
                        onChange={handleInputSearchChange}
                        onSearch={handleSearchClients}
                        onClear={handleClearInput}
                        sx={{ marginRight: '1rem' }}
                    />

                    <Paper sx={{ width: '100%', marginTop: '5rem' }}>
                        <TableContainer>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                size={'medium'}
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={rows.length}
                                />
                                <TableBody>
                                    {clients.map((row, index) => {

                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                tabIndex={-1}
                                                key={row.id}
                                                sx={{ cursor: 'pointer' }}
                                            >

                                                <TableCell align="left">{row.id}</TableCell>
                                                <TableCell align="left">{row.nameCompany}</TableCell>
                                                <TableCell align="left">{row.pIva}</TableCell>
                                                {roleUserId !== 2 && <TableCell align="left">{row?.user?.nameCompany ?? null}</TableCell>}
                                                <TableCell aria-describedby={idModifyClient} style={{display:'flex', flexDirection:'row',}} onClick={(event) => {
                                                    

                                                }} align="left"><span style={{
                                                    color:customTheme.colors.ui.grey, textDecoration:'underline', cursor:'pointer'
                                                }} onClick={() => {
                                                    setAddClientOpen(row)
                                                    setAgent(row?.agentId)
                                                    setFirstName(row?.firstName)
                                                    setLastName(row?.lastName)
                                                    setNameCompany(row?.nameCompany)
                                                    setPIva(row?.pIva)
                                                    setFiscalCode(row?.fiscalCode)
                                                    setAddressShipment(row?.addressShipment)
                                                    setRegisteredOffice(row?.registeredOffice)
                                                    setUsername(row?.username)
                                                    setTelNumber(row?.telNumber)
                                                }}>Dettagli</span> <DeleteForeverIcon onClick={() => {
                                                    setConfirmDeleteClient(true)
                                                    setCurrentClientId(row.id)
                                                }} style={{cursor:'pointer', color:customTheme.colors.ui.red, marginLeft:'1rem', position:'relative',}} /> </TableCell>
                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>



                </main>
            }
        </AppBar>
    )
}

export default Clients